"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _PatientAccountInfo = _interopRequireDefault(require("./PatientAccountInfo"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _PatientAccountInfo.default;
exports.default = _default;